export default {
  canAnswerQuestionOne: 'canAnswerQuestionOne',
  questionOneAnswered: 'questionOneAnswered',
  canAnswerQuestionTwo: 'canAnswerQuestionTwo',
  finished: 'finished',
}
